module.exports = __webpack_public_path__ + "static/media/20.9437c0c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/20.jpg
// module id = 281
// module chunks = 0